import { render, staticRenderFns } from "./stretch-page.vue?vue&type=template&id=402c77cf&scoped=true"
import script from "./stretch-page.vue?vue&type=script&lang=js"
export * from "./stretch-page.vue?vue&type=script&lang=js"
import style0 from "./stretch-page.vue?vue&type=style&index=0&id=402c77cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c77cf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonStretchFull: require('/builds/wj/fe/wenjuan-homesite/components/common/stretch-full.vue').default})
